import { Controller } from "react-hook-form";
import Select, { StylesConfig } from "react-select";

import CreatableSelect from "react-select/creatable";

import {
  SCHookFormprops,
  SCvalues,
} from "../../_helpers/commonComponentsTypes";


// LIEN UTILISE POUR LA CUSTO DES STYLES ---> https://codesandbox.io/s/s2g8e7?module=/example.tsx&file=/example.tsx:1627-1653
const colourStyles: StylesConfig<SCvalues, true> = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#FAFAFA",
    borderColor: "#ECECEC",
  }),
  container: (styles) => ({ ...styles, width: "100%", height: "38px" }),
  option: (styles, { isDisabled }) => {
    return {
      ...styles,
      backgroundColor: "#FAFAFA",
      color: "#000",
      cursor: isDisabled ? "not-allowed" : "default",
      ":hover": {
        ...styles[":active"],
        backgroundColor: "#641ABF",
        color: "#FFF",
      },
      /* ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? data.color
            : '#ECECEC'
          : undefined,
      }, */
    };
  },
  multiValue: (styles) => {
    return {
      ...styles,
      backgroundColor: "#641ABF",
    };
  },
  multiValueLabel: (styles) => ({
    ...styles,
    color: "#FFF",
  }),
  multiValueRemove: (styles) => ({
    ...styles,
    color: "#FFF",
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#6c757d",
  }),
};
const SelectCreatableHookForm = (props: SCHookFormprops) => {
  const formatCreateLabel = (inputValue: string) => `Ajouter ${inputValue}`;
  const noOptionsMessage = () => "Pas de résultats";

  return (
    <div
      style={{ zIndex: 100 }}
      className="d-flex justify-content-center align-items-center w-100 loader-height"
    >
      {props.creatable ? (
        <Controller
          control={props.control}
          name={props.name}
          render={(data) => (
            <CreatableSelect
              styles={colourStyles}
              onChange={(e) => {
                data.field.onChange(e);
              }}
              formatCreateLabel={formatCreateLabel}
              noOptionsMessage={noOptionsMessage}
              isMulti={props.isMulti ? true : undefined}
              options={props.options}
              defaultValue={props.defaultValue}
              placeholder={props.label ?? " "}
            />
          )}
        />
      ) : (
        <Controller
          control={props.control}
          name={props.name}
          render={(data) => (
            <Select
              styles={colourStyles}
              onChange={(e) => {
                data.field.onChange(e);
              }}
              noOptionsMessage={noOptionsMessage}
              isMulti={props.isMulti ? true : undefined}
              options={props.options}
              defaultValue={props.defaultValue}
              placeholder={props.label ?? " "}
            />
          )}
        />
      )}
    </div>
  );
};

export default SelectCreatableHookForm;
